import { render, staticRenderFns } from "./CurrentStageColumnTemplate.vue?vue&type=template&id=a3724ba6"
import script from "./CurrentStageColumnTemplate.vue?vue&type=script&lang=js"
export * from "./CurrentStageColumnTemplate.vue?vue&type=script&lang=js"
import style0 from "./CurrentStageColumnTemplate.vue?vue&type=style&index=0&id=a3724ba6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports